var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',_vm._l((_vm.agreements),function(agreement,i){return _c('property-agreement',{key:i,attrs:{"agreement":agreement},scopedSlots:_vm._u([{key:"list-item-content",fn:function(ref){
var agreement = ref.agreement;
return [_vm._t("list-item-content",null,null,{ agreement: agreement })]}}],null,true)})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }